<template>
  <div class="container_content role_wrapper">
    <div class="search">
      <div class="search_wrapper">
        <div class="search_wrapper_left"></div>
        <el-input
                v-model="roleName"
                placeholder="角色名搜索"
                style="width:150px;margin-right:10px;"
                @keyup.enter.native="search"
        />
        <el-button type="primary" size="small " @click="search()"
        ><i class="el-icon-search"></i><span>搜索</span>
        </el-button>
        <el-button size="small " @click="clearSearch()"
        ><i class="el-icon-refresh"></i><span>清空</span>
        </el-button>
      </div>
      <div class="options-wrapper flex-box">
        <el-button
          style="float: right"
          type="primary"
          @click="dowTemplate"
          icon="el-icon-document"
          v-if="routerData.includes('sys_role_add') || isAdmin"
        >模板
        </el-button
        >
        <el-button
          style="float: right"
          type="primary"
          @click="uploading"
          icon="el-icon-top"
          v-if="routerData.includes('sys_role_add') || isAdmin"
        >导入
        </el-button>
        <el-button
          style="float: right"
          type="primary"
          @click="downloadExcel"
          icon="el-icon-bottom"
          v-if="routerData.includes('sys_role_exp') || isAdmin"
        >导出
        </el-button>
        <el-button 
        type="success" 
        size="small " 
        @click="handleAdd()" 
        style="float: right"
        v-if="routerData.includes('sys_role_add') || isAdmin"
        ><i class="el-icon-plus"></i><span>新 增</span>
        </el-button>
      </div>
    </div>

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="教师" name="0"></el-tab-pane>
      <el-tab-pane label="学生" name="1"></el-tab-pane>
    </el-tabs>
    <div class="table_wrapper">
      <el-scrollbar style="height: 100%;">
        <el-table
          stripe
          v-loading="tableLoading"
          ref="multipleTable"
          :data="userData.data"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          header-row-class-name="table-head"
        >
          <el-table-column 
          type="selection" 
          width="55"
          :selectable="checkSelectable"
           align="center">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="65"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="roleName"
            label="角色名称"
            width="140"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="roleCode"
            label="角色标识"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="roleDesc"
            label="角色描述"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
                  prop="roleDesc"
                  label="角色类型"
                  align="center"
                  show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType =='0'">教师</span>
              <span v-if="scope.row.roleType =='1'">学生</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            width="170"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
             <!-- <el-button
                type="text"
                size="small "
                @click="viewDetail(scope.row)"
              >
                &lt;!&ndash; <i class="el-icon-view"></i> &ndash;&gt;
                <span>查看</span>
              </el-button>-->
              <el-button 
              :disabled="scope.row.sysFlag==0?true:false" 
              type="text" 
              size="small " 
              @click="edit(scope.row)"
              v-if="routerData.includes('sys_role_edit') || isAdmin"
              >
                <span>编辑</span>
              </el-button>
              <el-button 
              :disabled="scope.row.sysFlag==0?true:false" 
              type="text" 
              size="small " 
              @click="changePermission(scope.row)"
              v-if="routerData.includes('sys_role_edit') || isAdmin"
              >
                <span>权限</span>
              </el-button>
              <!-- <el-button
                type="text"
                size="small "
                @click="changePermission(scope.row)"
                ><span>权限</span>
              </el-button> -->
              <el-button
                type="text"
                size="small "
                @click="changeUser(scope.row)"
                v-if="routerData.includes('sys_role_edit') || isAdmin"
                ><span>用户</span>
              </el-button>
              <el-button
                type="text"
                size="small "
                @click="deleteRole(scope.row)"
                v-if="routerData.includes('sys_role_del') || isAdmin"
                ><span style="color: red">删除</span>
              </el-button>
              <!-- <el-button
                type="text"
                size="small "
                @click="changeUserType(scope.row)"
                ><span>用户类型</span>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
    <!-- 分页start -->
    <div style="margin-top: 20px;text-align:right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="current"
        layout="total,sizes,prev, pager, next"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="userData.total"
      >
      </el-pagination>
    </div>
    <!-- 分页end -->
    <!-- 弹窗表单start -->
    <roleFormDialog/>
    <!-- 弹窗表单end -->
    <!-- 权限、用户、用户类型弹窗start -->
    <userPermissionType ref="userPermissionType" :type="activeName" />
    <!-- 弹窗表单end -->

    <importExcel
      ref="uplodModal"
      :uplodData="uplodData"
      @closeUplod="closeUplod"
    ></importExcel>

    <el-dialog
      class="permission-dialog"
      :close-on-click-modal="false"
      :visible.sync="permissionDialog"
      width="480px"
      title="权限设置"
      :modal="false"
    >
      <div v-loading="permissionLoading || routeLoading">
        <div class="tree-box">
          <el-tree ref="tree" class="card-tree"
                   :data="routeList"
                   show-checkbox
                   node-key="id"
                   :props="props"
                   default-expand-all
                   :check-strictly="checkStrictly"
                   :default-checked-keys="checkedArr"></el-tree>
        </div>
        <div class="w100 mt10 tx-c" v-if="routeList.length">
          <el-button @click="updata" type="primary" :disabled="permissionLoading || routeLoading">保存</el-button>
          <el-button @click="permissionDialog=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoleTableData,
  removeMultipleRole,
  getRolePermission,
  removeRoleById,
  updateRolePermission,
} from "@/api/system/role";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { mapGetters, mapMutations } from "vuex";
import roleFormDialog from "@/components/dialog/roleManage/index.vue";
import userPermissionType from "@/components/dialog/roleManage/userPermissionType.vue";
import {fetchMenuTree} from '@/api/admin/menu'
import {excelExport} from '@/api/importAndExport/excelApi';
import importExcel from "@/components/dialog/deptManage/importExcel.vue";

export default {
  name: "roleManage",
  data() {
    return {
      tableLoading: false,
      roleName: "",
      multipleSelection: [],
      current: 1,
      pageSize: 10,
      userData: {
        data: [],
        total: 0,
        pageSize: ""
      },
      activeName: "0",
      dealRoleType: dealRoleType,
      dealRoleTypeData: dealRoleTypeData,
      stringToArray: stringToArray,
      permissionDialog: false,
      routeList: [],
      props: {
        label: "label",
        disabled: data => {
          if (data.isShow == 1) {
            return true;
          }
          return false;
        }
      },
      checkedArr: [],
        checkStrictly: false,
      roleId: '',
      permissionLoading: false,
      routeLoading: false,
      uplodData: {
        state: false,
        type: ""
      },
      routerData: [],
    };
  },
  components: {
    roleFormDialog,
    userPermissionType,
    importExcel,
  },
  computed: {
    ...mapGetters([
      "userMenus",
      "roleTypeData",
      // "dialogTittle",
      "userPermissionTypeDialog",
      "defaultCheckedArray",
    ]),
    isdisabled() {
      return this.multipleSelection.length > 0? false : true;
    }
  },
  watch: {},
  created() {
    this.setDialogVisible(false);
    this.setPermissionDialog(false);
    this.getTableData();
    this.$store.dispatch("GetUserMenu").then((data) => {})

    this.routerData = this.$store.getters.userData.routerData;
  },
  methods: {
    ...mapMutations({
      setDialogVisible: "setDialogVisible",
      setPermissionDialog: "setPermissionDialog",
      setCurrentRowData: "setCurrentRowData",
      setRoleFormData: "setRoleFormData",
      // clearRoleFormData: "clearRoleFormData",
      setDialogTittle: "setDialogTittle",
      setRoleFormDialogStatus: "setRoleFormDialogStatus",
      setPromptType: "setPromptType",
      // setStatus: "setStatus",
      setCurrentRoleId: "setCurrentRoleId",
      setPromptTittle: "setPromptTittle",
      setAddRoleFormData: "setAddRoleFormData",
      clearDefaultChecked: "clearDefaultChecked",
      setDefaultChecked: "setDefaultChecked"
    }),
    isAdmin(){
      return (this.$store.getters.userData.roleCodes||[]).includes('ROLE_ADMIN')
    },
    // 下载模板
    dowTemplate() {
      this.$DownLoad(
        "/admin/excel/download?type=role",
        null,
        res => {
          if (res.status == 200) {
            // this.$message.success("开始下载");
          } else {
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        },
        error => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      );
    },
    uploading() {
      this.uplodData.state = true;
      this.uplodData.type = "role";
    },
    closeUplod(val) {
      this.uplodData.state = val;
      
      this.getTableData()
    },
    downloadExcel(){
      this.$DownLoad(
        excelExport('role'),
        null,
        res => {
          if (res.status == 200) {
            // this.$message.success("开始下载");
          } else {
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        },
        error => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      );
    },
    handleClick(tab, event) {
      this.current = 1;
      this.getTableData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getTableData();
    },
// 设置表格行不可选
    checkSelectable(row, index) {
      if (row.sysFlag == 0) {
        return false;
      }
      return true;
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        size: this.pageSize,
        current: this.current,
        type: this.activeName
      };
      if (this.roleName) {
        params.keywords = this.roleName;
      }
      getRoleTableData(params).then(res => {
        if (res.data.code == 0) {
          this.setUserData(res.data.data);
        }else {
          this.$message.error(res.data.msg)
        }
      });
    },
    setUserData(data) {
      this.userData.total = data.total;
      this.userData.data = data.records;
      this.tableLoading = false;
      this.userData.data.forEach((item, index) => {
        this.userData.data[index].dealMenus = this.stringToArray(item.menus);
      });
      //   this.userData.pageSize = this.initpage.pageSize;
    },
    // 查看角色
    viewDetail(params) {
        this.setCurrentRowData(params);
      this.setRoleFormData(params);
      this.setDialogVisible(true);
      this.setDialogTittle("角色详情");
      this.setRoleFormDialogStatus("view");
    },
    // 修改角色
    edit(params) {
      this.setAddRoleFormData();
      this.setRoleFormData(params);
      this.setDialogVisible(true);
      this.setDialogTittle("编辑");
      this.setRoleFormDialogStatus("edit");
    },
    // 添加角色
    handleAdd() {
      this.setAddRoleFormData(Number(this.activeName));
      // this.clearRoleFormData(this.activeName);
      this.setDialogVisible(true);
      this.setDialogTittle("新增");
      this.setRoleFormDialogStatus("add");
    },
    // 批量删除
    handleDelete() {
      var that = this;
      if (this.multipleSelection.length > 0) {
        this.$confirm("确定删除选中的角色？", "提示", {
          type: "warning"
        }).then(() => {
          const idArr = this.multipleSelection.map(item => {
            return item.roleId;
          });
          removeMultipleRole({ idArr })
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success("删除成功");
                if (
                  this.userData.data.length === idArr.length &&
                  this.current > 1
                ) {
                  this.userData.total -= 1;
                  this.current -= 1;
                }
                this.getTableData();
              } else {
                this.$alert(res.data.msg, "提示", {
                  confirmButtonText: "确定",
                  type: "warning"
                });
              }
            })
            .catch(err => {
              this.$message.error("删除失败");
            });
        });
      } else {
        this.$Message.destroy();
        this.$Message.warning("请选择目标项");
      }
    },
    // 单个删除
    deleteRole(row){
      this.$confirm(`确定删除${row.roleName}？`, "提示", {
        type: "warning"
      }).then(() => {
        removeRoleById(row.roleId).then((res) => {
          if (res.data.code == 0) {
            this.$message.success("删除成功");
            if (
              this.userData.data.length === 1 &&
              this.current > 1
            ) {
              this.userData.total -= 1;
              this.current -= 1;
            }
            this.getTableData();
          } else {
            this.$alert(res.data.msg, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        })
      })
      .catch(err => {
        this.$message.error("删除失败");
      });
    },
    search() {
      this.current = 1;
      this.getTableData();
    },
    clearSearch() {
      this.roleName = "";
      this.getTableData();
    },
    changePermission(row) {
      this.fetchRouteList()
      this.permissionDialog = true
      this.$nextTick(function () {
          //Dom更新完毕
          this.$refs.tree.setCheckedKeys([]);
      });
      this.fetchRoleForRouteList(row)
      this.roleId = row.roleId
    },
    // 根据角色id查询拥有的路由列表
    fetchRoleForRouteList(row) {
      this.permissionLoading = true;
        this.checkStrictly = true
      getRolePermission(row)
      .then(({data}) => {
        if (data.code == 0) {
          // 设置勾选
          // this.strictly = true;
          this.$nextTick(() => {
              console.log(data.data,'data.data');
              this.$refs.tree.setCheckedKeys(data.data);
            // this.$refs.tree.setCheckedKeys([1060,1059]);
            // this.strictly = false;
              this.checkStrictly = false
          });
        }
        this.permissionLoading = false;
      })
      .catch(() => {
        this.permissionLoading = false;
      })
    },
    changeUser(row) {
      this.setCurrentRoleId(row.roleId);
      this.setPermissionDialog(true);
      this.setPromptTittle(`【${row.roleName}】选择用户`);
      this.setPromptType("selectUser");
      this.$refs.userPermissionType.selectUser.current = 1;
      this.$refs.userPermissionType.getRoleUsersData();
    },
    changeUserType(row) {
      this.setCurrentRoleId(row.roleId);
      this.setPermissionDialog(true);
      this.setPromptTittle(`【${row.roleName}】选择用户类型`);
      this.setPromptType("selectUserType");
      this.clearDefaultChecked();
      this.$refs.userPermissionType.utypesArray = [];
      this.$refs.userPermissionType.getRoleUserTypesData();
    },
    // 获取所有的路由树状结构
    fetchRouteList() {
      this.routeLoading = true;

      fetchMenuTree()
      .then(({data}) => {
        this.routeList = data.data;
        this.routeLoading = false;
      })
      .catch(() => {
        this.routeLoading = false;
      });
    },
    // 保存修改
    updata() {
      const arr = this.$refs.tree.getCheckedNodes(false, true);
      this.permissionLoading = true;
      const roleId = this.roleId;
      const menuIds = arr.map(val => val.id);
      let params = {roleId, menuIds}
      updateRolePermission(params)
      .then(({data}) => {
        if (data.code == 0) {
          this.$message.success("修改权限成功");
          this.permissionDialog = false;
        }
        this.permissionLoading = false;
      })
      .catch(() => {
        this.permissionLoading = false;
      })
    },
  }
};
</script>

<style lang="less" scoped>
@import url("index.less");
.permission-dialog {
  /deep/ .el-dialog__body {
    .tree-box {
      height: 60vh;
      overflow-y: auto;
    }
  }
}
</style>